module.exports = __webpack_public_path__ + "static/media/Renderman-Logo.2026cc95.jpg";